<template>
  <header class="bndbs-navbar navbar navbar-expand bg-body border-bottom">
    <div class="container-fluid">
      <!-- همبرگر + عنوان صفحه -->
      <button
        type="button"
        class="btn btn-link text-body p-2 me-2"
        aria-label="باز/بستن منو"
        @click="toggleSideNav()"
      >
        <i class="fas fa-bars"></i>
      </button>
      <span class="navbar-text fw-bold text-truncate">{{ page }}</span>

      <div class="ms-auto d-flex align-items-center gap-1">
        <!-- تغییر حالت نمایش -->
        <button
          type="button"
          class="btn btn-link text-body theme-toggle-btn"
          :aria-label="'تغییر حالت نمایش، فعلی: ' + themeLabel"
          :title="'نمایش: ' + themeLabel"
          @click="cycleTheme"
        >
          <i :class="'fas ' + themeIcon"></i>
          <span class="d-none d-lg-inline-block ms-1">{{ themeLabel }}</span>
        </button>

        <!-- اطلاعیه‌ها -->
        <b-dropdown
          variant="link"
          toggle-class="text-body text-decoration-none position-relative"
          no-caret
          placement="bottom-end"
          menu-class="notif-menu"
        >
          <template #button-content>
            <i class="fas fa-bell"></i>
            <span class="d-none d-md-inline-block ms-1">اطلاعیه</span>
            <span
              v-if="countNotification > 0"
              class="badge rounded-pill bg-danger notif-badge"
              >{{ countNotification }}</span
            >
          </template>
          <b-dropdown-item
            v-for="notification in notifications"
            :key="notification.NotificationId"
            :class="notification.Seen ? '' : 'fw-bold'"
            @click="checkNotification(notification)"
          >
            <div class="d-flex justify-content-between small text-secondary">
              <span>{{ notification.Title }}</span>
              <span><i class="far fa-clock"></i> {{ notification.LastUpdate }}</span>
            </div>
            <p class="limit-2-line-text small mb-0">{{ notification.Body }}</p>
          </b-dropdown-item>
          <b-dropdown-text
            v-if="!notifications || !notifications.length"
            class="text-secondary small"
          >
            اطلاعیه‌ای وجود ندارد.
          </b-dropdown-text>
        </b-dropdown>

        <!-- منوی کاربر -->
        <b-dropdown
          variant="link"
          toggle-class="text-body text-decoration-none"
          no-caret
          placement="bottom-end"
        >
          <template #button-content>
            <i class="fas fa-user"></i>
            <span class="d-none d-sm-inline-block ms-1">بیشتر</span>
          </template>
          <b-dropdown-item @click="editProfile">پروفایل</b-dropdown-item>
          <b-dropdown-item @click="changePassword">تغییر رمز عبور</b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="signout">خروج</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";
import {
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BDropdownText,
} from "bootstrap-vue-next";
import { actionTypes } from "@/store-types";
import notificationApi from "@/api/notificationApi";
import { getStoredTheme, setTheme, nextThemeMode } from "@/utils/theme";

const THEME_ICONS = { light: "fa-sun", dark: "fa-moon", auto: "fa-adjust" };
const THEME_LABELS = { light: "روشن", dark: "تیره", auto: "خودکار" };

export default {
  name: "AppNavbar",
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BDropdownText,
  },
  props: {
    page: { type: String, default: "" },
  },
  data() {
    return {
      notifications: null,
      themeMode: getStoredTheme(),
    };
  },
  computed: {
    themeIcon() {
      return THEME_ICONS[this.themeMode] || "fa-adjust";
    },
    themeLabel() {
      return THEME_LABELS[this.themeMode] || "خودکار";
    },
    countNotification() {
      if (!Array.isArray(this.notifications)) return 0;
      return this.notifications.filter((n) => !n.Seen).length;
    },
  },
  methods: {
    ...mapActions(["toggleSideNav"]),
    cycleTheme() {
      this.themeMode = setTheme(nextThemeMode(this.themeMode));
    },
    signout() {
      this.$store.dispatch(actionTypes.CLEAR_LOGIN);
      this.$router.go(0);
    },
    editProfile() {
      this.$router.push({
        name: "EditProfile",
        params: { id: this.$store.state.user.UserId },
      });
    },
    changePassword() {
      this.$router.push({
        name: "ChangePassword",
        params: { id: this.$store.state.user.UserId },
      });
    },
    checkNotification(notification) {
      notificationApi
        .seenNotification({ NotificationId: notification.NotificationId })
        .then(
          ({ data }) => {
            if (data.Status == 1) {
              notification.Seen = true;
              if (notification.Type == 1) {
                this.$router.push({
                  name: "Invoice",
                  params: { invoiceId: notification.InvoiceId },
                });
              } else if (notification.Type == 2) {
                this.$router.push({
                  name: "Ticket",
                  params: { ticketId: notification.TicketId },
                });
              } else if (notification.Type == 3) {
                this.$router.push({
                  name: "Service",
                  params: { serviceId: notification.ServiceId },
                });
              } else {
                window.location.href = notification.Url;
              }
            } else {
              this.$toastr.s(data.Message, "اعلان‌ها");
            }
          },
          (r) => {
            console.error(r);
          }
        );
    },
  },
  mounted() {
    if (this.$store.state.signedIn) {
      this.notifications = this.$store.state.notifications;
      notificationApi.getNotification().then(
        ({ data }) => {
          this.$store.state.notifications = data;
          this.notifications = data;
        },
        (r) => {
          console.error(r);
        }
      );
    }
  },
};
</script>

<style scoped>
.bndbs-navbar {
  position: sticky;
  top: 0;
  z-index: 1030;
  min-height: 56px;
}
.theme-toggle-btn {
  text-decoration: none;
}
.notif-badge {
  position: absolute;
  top: -2px;
  inset-inline-end: -6px;
  font-size: 10px;
}
.limit-2-line-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 20rem;
}
:deep(.notif-menu) {
  width: 22rem;
  max-height: 24rem;
  overflow-y: auto;
}
</style>
